import React, { useState } from 'react';
import { CgChevronDown, CgChevronLeft } from 'react-icons/cg';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const menuData = [
    {
        title: 'Home',
        path: '/',
        icon: <span className="material-symbols-outlined" aria-hidden="true">home</span>,
        iconClosed: <CgChevronLeft />,
        iconOpened: <CgChevronDown />,
    },
    {
        title: 'Directory',
        path: '#',
        icon: <span className="material-symbols-outlined" aria-hidden="true">explore</span>,
        iconClosed: <CgChevronLeft />,
        iconOpened: <CgChevronDown />,
        subNav: [
            { title: 'Browse All', path: '/browse', cName: 'sub-nav' },
            { title: 'Farms', path: '/category/farms', cName: 'sub-nav' },
            { title: 'Farmers Markets', path: '/category/farmers-markets', cName: 'sub-nav' },
            { title: 'CSA Programs', path: '/category/csa-programs', cName: 'sub-nav' },
            { title: 'Seasonal Guide', path: '/seasonal', cName: 'sub-nav' },
            { title: 'Map View', path: '/map', cName: 'sub-nav' },
        ],
    },
    {
        title: 'Recipes',
        path: '/recipes',
        icon: <span className="material-symbols-outlined" aria-hidden="true">restaurant</span>,
        iconClosed: <CgChevronLeft />,
        iconOpened: <CgChevronDown />,
        subNav: [
            { title: 'All Recipes', path: '/recipes', cName: 'sub-nav' },
            { title: 'Quick Recipes', path: '/recipes?filter=quick', cName: 'sub-nav' },
            { title: 'Seasonal Recipes', path: '/recipes?filter=seasonal', cName: 'sub-nav' },
            { title: 'Vegetarian', path: '/recipes?diet=vegetarian', cName: 'sub-nav' },
            { title: 'Vegan', path: '/recipes?diet=vegan', cName: 'sub-nav' },
            { title: 'Gluten-Free', path: '/recipes?diet=gluten-free', cName: 'sub-nav' },
        ],
    },
    {
        title: 'Guides',
        path: '/seasonal-guides',
        icon: <span className="material-symbols-outlined" aria-hidden="true">menu_book</span>,
        iconClosed: <CgChevronLeft />,
        iconOpened: <CgChevronDown />,
        subNav: [
            { title: 'All Seasonal Guides', path: '/seasonal-guides', cName: 'sub-nav' },
            { title: "What's In Season", path: '/seasonal', cName: 'sub-nav' },
            { title: 'Blog Posts', path: '/events', cName: 'sub-nav' },
            { title: 'Shopping Guide', path: '/guide/shopping-at-farmers-markets', cName: 'sub-nav' },
        ],
    },
    {
        title: 'Produce',
        path: '/produce-directory',
        icon: <span className="material-symbols-outlined" aria-hidden="true">nutrition</span>,
        iconClosed: <CgChevronLeft />,
        iconOpened: <CgChevronDown />,
        subNav: [
            { title: 'All Produce', path: '/produce-directory', cName: 'sub-nav' },
            { title: 'In Season Now', path: '/seasonal', cName: 'sub-nav' },
            { title: 'Fruits', path: '/produce?category=fruit', cName: 'sub-nav' },
            { title: 'Vegetables', path: '/produce?category=vegetable', cName: 'sub-nav' },
            { title: 'Herbs', path: '/produce?category=herb', cName: 'sub-nav' },
        ],
    },
    {
        title: 'Search',
        path: '/search',
        icon: <span className="material-symbols-outlined" aria-hidden="true">search</span>,
    },
    {
        title: 'Favorites',
        path: '/favorites',
        icon: <span className="material-symbols-outlined" aria-hidden="true">favorite</span>,
    },
    {
        title: 'Compare',
        path: '/compare',
        icon: <span className="material-symbols-outlined" aria-hidden="true">compare_arrows</span>,
    },
    {
        title: 'Events',
        path: '/events',
        icon: <span className="material-symbols-outlined" aria-hidden="true">event</span>,
    },
    {
        title: 'About',
        path: '/about',
        icon: <span className="material-symbols-outlined" aria-hidden="true">info</span>,
    },
    {
        title: 'Contact',
        path: '/contact',
        icon: <span className="material-symbols-outlined" aria-hidden="true">call</span>,
    },
];

const SidebarLink = styled(Link)`
    display: flex;
    color: #fff;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    list-style: none;
    text-decoration: none;
    font-size: 16px;
    font-weight: 600;
    border-radius: 14px;
    margin: 6px 10px;
    &:hover {
        background: rgba(255, 255, 255, 0.08);
        color: #fff;
        cursor: pointer;
    }
`;

const SidebarLabel = styled.span`
    margin-left: 16px;
    color: #fff;
    font-weight: 400;
`;

const DropdownLink = styled(Link)`
    padding: 14px 20px 14px 56px;
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    margin: 0 10px 6px;
    border-radius: 14px;
    &:hover,
    &:active {
        background: rgba(255, 255, 255, 0.08);
        cursor: pointer;
        color: #fff;
    }
`;

const SubMenu = ({ item }) => {
    const [subnav, setSubnav] = useState(false);

    const showSubnav = () => setSubnav(!subnav);

    return (
        <>
            <SidebarLink to={process.env.PUBLIC_URL + `${item.path}`} onClick={item.subNav && showSubnav}>
                <div>
                    {item.icon}
                    <SidebarLabel>{item.title}</SidebarLabel>
                </div>
                <div>
                    {item.subNav && subnav ? item.iconOpened : item.subNav ? item.iconClosed : null}
                </div>
            </SidebarLink>
            {subnav &&
                item.subNav.map((data, index) => (
                    <DropdownLink to={process.env.PUBLIC_URL + `${data.path}`} key={index}>
                        {item.icon}
                        <SidebarLabel>{data.title}</SidebarLabel>
                    </DropdownLink>
                ))}
        </>
    );
};

const MenuButton = styled.button`
    color: var(--thm-base);
    background: rgba(0, 0, 0, 0.02);
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 999px;
    width: 42px;
    height: 42px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    cursor: pointer;
    transition: transform 140ms ease, background 140ms ease, border-color 140ms ease;

    &:hover {
        transform: translateY(-1px);
        background: rgba(var(--thm-base-rgb), 0.08);
        border-color: rgba(var(--thm-base-rgb), 0.22);
    }

    .material-symbols-outlined {
        font-size: 24px;
    }
`;

const SidebarNav = styled.nav`
    background: linear-gradient(180deg, rgba(var(--thm-base-rgb), 0.98), rgba(var(--thm-base-rgb), 0.92));
    width: min(360px, 92vw);
    height: 100%;
    position: fixed;
    overflow-y: scroll;
    scroll-behavior: smooth;
    -webkit-scroll-behavior: smooth;
    box-shadow: 0 22px 60px rgba(0, 0, 0, 0.28);
    top: 0;
    right: ${({ sidebar }) => (sidebar ? '0' : '-100%')};
    transition: 350ms;
    z-index: 99999;
`;

const SidebarWrap = styled.div`
    width: 100%;
`;

const MobileMenu = () => {
    const [sidebar, setSidebar] = useState(false);

    const showSidebar = () => setSidebar(!sidebar);
    let publicUrl = process.env.PUBLIC_URL+'/'

    return (
        <>
            <>
                <MenuButton
                    type="button"
                    className="freshswfl-mobile-menu-trigger"
                    onClick={showSidebar}
                    aria-label="Open menu"
                >
                    <span className="material-symbols-outlined" aria-hidden="true">menu</span>
                </MenuButton>

                <SidebarNav sidebar={sidebar}>
                    <SidebarWrap>
                        <div className="mobile-nav__content">
                            <div className="logo-box">
                                <Link to={process.env.PUBLIC_URL + `/`} aria-label="FreshSWFL.com">
                                    <img src={publicUrl + "favicon.svg"} width="36" alt="FreshSWFL.com" />
                                </Link>
                            </div>
                            <MenuButton
                                type="button"
                                onClick={showSidebar}
                                aria-label="Close menu"
                                style={{
                                    marginLeft: 'auto',
                                    color: 'white',
                                    background: 'rgba(255, 255, 255, 0.06)',
                                    borderColor: 'rgba(255, 255, 255, 0.12)',
                                }}
                            >
                                <span className="material-symbols-outlined" aria-hidden="true">close</span>
                            </MenuButton>
                            {menuData.map((item, index) => (
                                <SubMenu item={item} key={index} />
                            ))}
                            <ul className="mobile-nav__contact list-unstyled">
                                <li>
                                    <i className="fa fa-envelope" aria-hidden="true"></i>
                                    <a href="mailto:needhelp@packageName__.com">needhelp@const.com</a>
                                </li>
                                <li>
                                    <i className="fa fa-phone" aria-hidden="true"></i>
                                    <a href="tel:666-888-0000">666 888 0000</a>
                                </li>
                            </ul>
                            <div className="mobile-nav__top">
                                <div className="mobile-nav__social">
                                    <a href="https://twitter.com/"><span className="fab fa-twitter"></span></a>
                                    <a href="https://facebook.com/"><span className="fab fa-facebook-square"></span></a>
                                    <a href="https://pinterest.com/"><span className="fab fa-pinterest-p"></span></a>
                                    <a href="https://instagram.com/"><span className="fab fa-instagram"></span></a>
                                </div>
                            </div>
                        </div>
                    </SidebarWrap>
                </SidebarNav>
            </>
        </>
    );
};

export default MobileMenu;
